/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "banklin": {
        "nested": {
          "octopus": {
            "nested": {
              "OctopusResult": {
                "values": {
                  "SUCCESS": 1,
                  "GENERIC_FAILURE": 2,
                  "TRANSPORT_ERROR": 3,
                  "UNSUPPORTED_INSTRUMENT": 4,
                  "INSUFFICIENT_FUNDS": 5,
                  "INVALID_INSTRUMENT": 6,
                  "INSTRUMENT_EXPIRED": 7,
                  "CARD_LOST_OR_STOLEN": 8,
                  "INVALID_CVV": 9,
                  "DECLINED": 10,
                  "FAILED_TO_REACH_ISSUER": 11,
                  "LEASE_EXPIRED": 12,
                  "INVALID_ROUTING_NUMBER": 13,
                  "CONTACT_ACQUIRER": 14,
                  "PICK_UP_CARD": 15,
                  "SUSPECTED_FRAUD": 16,
                  "DO_NOT_HONOR": 17,
                  "REENTER_TRANSACTION": 18,
                  "ACCOUNT_FROZEN": 19,
                  "FAILED_BANKBOOK_VALIDATION": 23,
                  "INVALID_BANKBOOK_ACCOUNT": 34,
                  "BANKBOOK_CREDENTIALS_EXPIRED": 33,
                  "POTENTIALLY_INSUFFICIENT_FUNDS": 20,
                  "INSTRUMENT_DISABLED": 21,
                  "UNSUPPORTED_CURRENCY": 22,
                  "INVALID_AVS": 24,
                  "UNACTIVATED_INSTRUMENT": 25,
                  "INVALID_PIN": 26,
                  "OVER_LIMIT": 27,
                  "TOO_MANY_ACTIVATION_ATTEMPTS": 28,
                  "MANUAL_REVIEW": 29,
                  "UNSUPPORTED_COUNTRY": 30,
                  "CHIP_ERROR": 31,
                  "INVALID_AMOUNT": 32,
                  "BLOCKED_BY_FRISKY": 35,
                  "RESTRICTED_CARD": 36,
                  "TRANSACTION_NOT_PERMITTED": 37,
                  "AUTHENTICATION_REQUIRED": 38,
                  "INVALID_MERCHANT": 40,
                  "INVALID_EXPIRATION": 41,
                  "SUSPECTED_STOLEN": 42,
                  "DECLINED_CARD_LOCKED": 43,
                  "UNSUPPORTED_MCC": 44,
                  "ACCOUNT_DENYLISTED": 45,
                  "ACCOUNT_EXTERNAL_SUSPENDED": 46,
                  "CARD_TERMINATED": 47,
                  "UNSUPPORTED_REASON_CODE": 48,
                  "MOBILE_WALLET_ERROR": 49,
                  "STOP_PAYMENT": 50,
                  "REVOCATION_OF_AUTH": 51,
                  "MERCHANT_BLOCKED_FOR_SPONSORED_CUSTOMER": 52,
                  "MERCHANT_BLOCKED_BY_CUSTOMER": 53,
                  "PIN_TRY_LIMIT_EXCEEDED": 54,
                  "AUTO_REVERSAL": 55,
                  "AUTO_REVERSAL_WITH_MANUAL_REVIEW": 56,
                  "IN_APP_AUTHENTICATION_REQUIRED": 57,
                  "DUPLICATE_TRANSACTION": 58,
                  "AUTHENTICATION_FAILED": 59,
                  "LINKED_ACCOUNT_LIMIT_EXCEEDED": 61,
                  "STORED_VALUE_REQUIRED": 62,
                  "DIDV_REQUIRED": 63,
                  "BNF_NAME_REQUIRED": 64,
                  "CREDIT_LIMIT_EXCEEDED": 65,
                  "INVALID_USE_OF_CASH_CARD": 66,
                  "INSTRUMENT_INCURS_ADDITIONAL_FEES": 67
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banklin?.nested?.octopus?.nested?.OctopusResult) {
	$root.addJSON(jsonData);
}

/**
 * uuuuuuuuuuuuuuuuuuuu
 *           u" uuuuuuuuuuuuuuuuuu "u
 *         u" u$$$$$$$$$$$$$$$$$$$$u "u
 *       u" u$$$$$$$$$$$$$$$$$$$$$$$$u "u
 *     u" u$$$$$$$$$$$$$$$$$$$$$$$$$$$$u "u
 *   u" u$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$u "u
 * u" u$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$u "u
 * $ $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ $
 * $ $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ $
 * $ $$$" ... "$...  ...$" ... "$$$  ... "$$$ $
 * $ $$$u `"$$$$$$$  $$$  $$$$$  $$  $$$  $$$ $
 * $ $$$$$$uu "$$$$  $$$  $$$$$  $$  """ u$$$ $
 * $ $$$""$$$  $$$$  $$$u "$$$" u$$  $$$$$$$$ $
 * $ $$$$....,$$$$$..$$$$$....,$$$$..$$$$$$$$ $
 * $ $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ $
 * "u "$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$" u"
 *   "u "$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$" u"
 *     "u "$$$$$$$$$$$$$$$$$$$$$$$$$$$$" u"
 *       "u "$$$$$$$$$$$$$$$$$$$$$$$$" u"
 *         "u "$$$$$$$$$$$$$$$$$$$$" u"
 *           "u """""""""""""""""" u"
 *             """"""""""""""""""""
 *
 * Hey, you! Yes, you there. I see you, about to add an enum to this file. "What's the harm?", you
 * ask. "It's just an enum in a proto file!" Unfortunately, OctopusResult is used in several
 * database schemas as an enum type (namely, Franklin and Banklin). Historically, these services
 * used the AbstractSchemaCompatibilityCheckTest from Service Container to verify that each enum
 * value was present in the database schema, auto-failing the test if not. That implies that adding
 * a new value here used to break topographer upgrades for Franklin / Banklin, until a schema shift
 * was created to add the new values to their respective databases.
 *
 * To avoid this, Franklin and Banklin have both created forks of OctopusResult, i.e. enum
 * declarations that they use exclusively at the database level (in Franklin, DbPaymentPull,
 * DbPaymentPush, PaymentPullRow, PaymentPushRow; in Banklin DbTransaction, DbTransactionEvent,
 * BalanceTester). Adding values here no longer breaks these systems on upgrade, however
 *
 *    --> YOU MUST STILL CREATE AND RUN SHIFTS FOR FRANKLIN AND BANKLIN AT APPROPRIATE TIMES <--
 *
 * If you do not do so, passing new OctopusResults to these systems to persist would result in
 * IllegalStateExceptions at runtime. Please do not allow this to happen. Be a good citizen. If you
 * are going to add values here, be sure to also get them added in both Franklin and Banklin too.
 * Yes, it will take a long time. Yes, it is annoying. Yes, we will all be mad at you if you break
 * Franklin or Banklin. If you are unsure, ask someone with more historical context for help!
 * Thank you for attending my TED Talk.
 *
 * SOURCE OctopusResult @ squareup/banklin/octopus.proto at 53:1
 */
export const OctopusResult = $root.lookupEnum('squareup.banklin.octopus.OctopusResult').values;
